import React from "react"
import styled from "styled-components"

type AlignType = "start" | "center" | "stretch"

const ConfirmWrapperStyled = styled.div<{
    show: boolean
}>`
    position: fixed;
    width: ${(props) => (props.show ? "100%" : 0)};
    height: ${(props) => (props.show ? "100%" : 0)};
    top: 0;
    left: 0;
    z-index: 10;
    overflow: hidden;
    background: ${(props) => props.theme.confirmWrapperBackground};
`
const ConfirmStyled = styled.div<{
    align: AlignType
    maxWidth?: number
}>`
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: ${(props) => props.align};
    width: calc(100% - 24px);
    min-height: 200px;
    max-height: 500px;
    max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : "500px")};
    left: 50%;
    top: 50%;
    padding: 15px 15px 60px;
    transform: translate(-50%,-50%);
    border-radius: 2px;
    background: ${(props) => props.theme.confirmBackground};
`
export const ConfirmTitle = styled.div`
    max-width: 100%;
    font-size: 16px;
    font-weight: 600;
    font-family: ${(props) => props.theme.openSans};
    margin-bottom: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`
export const ConfirmDescription = styled.div<{
    align?: AlignType
}>`
    width: 100%;
    max-height: 380px;
    text-align: ${(props) => (props.align || "inherit")};
    margin-bottom: 10px;
    overflow: auto;
    color: ${(props) => props.theme.confirmDescriptionColor};
`
export const ConfirmBottom = styled.div`
    position: absolute;
    bottom: 15px;
    right: 15px;
`


let clickStart: number = null
let clickEnd: number = null


interface ConfirmWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    show: boolean
    children: React.ReactNode
    onClose: () => void
}
export const ConfirmWrapper = ({
    show,
    children,
    onClose,
}: ConfirmWrapperProps) => (
    <ConfirmWrapperStyled
        show={show}
        onMouseUp={() => {
            if (clickStart === null && clickEnd === null) {
                onClose()
            }
            clickStart = null
            clickEnd = null
        }}
        onClick={(e) => e.stopPropagation()}
    >
        {children}
    </ConfirmWrapperStyled>
)


interface ConfirmProps {
    align?: AlignType
    maxWidth?: number
    children: React.ReactNode
    onClick?: React.MouseEventHandler<HTMLDivElement>
}
export const Confirm = ({
    align = "stretch",
    maxWidth = null,
    children,
    onClick = null,
}: ConfirmProps) => (
    <ConfirmStyled
        align={align}
        maxWidth={maxWidth}
        onMouseDown={() => { clickStart = 1 }}
        onMouseUp={() => { clickEnd = 1 }}
        onClick={onClick}
    >
        {children}
    </ConfirmStyled>
)
